import { formatNumber } from "accounting"
import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import EmptyComponent from "../../../../../Components/Empty"
import Private from "../../../../../Components/Private"

const { Text } = Typography

// Mobile stand-in for the "Bank breakdown" table: one card per bank showing every numeric
// column at once, instead of picking a single column via a select - same pattern as
// AlertsByCountryMobileTable.
const AlertsByBankMobileTable = ({ rows, searchTerm }) => {
  const { t } = useTranslation()

  if (!rows.length) {
    return searchTerm ? (
      <EmptyComponent type="search" style={{ minHeight: 450 }} />
    ) : (
      <EmptyComponent type="no_data_available" style={{ minHeight: 450 }} />
    )
  }

  return (
    <Flex vertical gap={12} className="breakdown-mobile-cards">
      {rows.map((record) => (
        <div key={record.label} className="breakdown-mobile-card">
          <Flex vertical gap={4} className="breakdown-mobile-card__row">
            <Text type="secondary">{t("Bank name")}</Text>
            <Text strong ellipsis>
              {record.label || "N/A"}
            </Text>
          </Flex>

          <Flex gap={12} className="breakdown-mobile-card__grid">
            <Flex vertical gap={4} className="breakdown-mobile-card__stat">
              <Text type="secondary">{t("Count")}</Text>
              <Text strong>{formatNumber(record?.count)}</Text>
            </Flex>
            <Flex vertical gap={4} className="breakdown-mobile-card__stat">
              <Text type="secondary">{t("Volume ($)")}</Text>
              <Text strong>
                <Private>{`$${formatNumber(record?.volume, 2, ",")}`}</Private>
              </Text>
            </Flex>
          </Flex>

          <Flex gap={12} className="breakdown-mobile-card__grid">
            <Flex vertical gap={4} className="breakdown-mobile-card__stat">
              <Text type="secondary">{t("Average alert value")}</Text>
              <Text strong>
                <Private>{`$${formatNumber(record?.average ?? 0, 2, ",")}`}</Private>
              </Text>
            </Flex>
            <Flex vertical gap={4} className="breakdown-mobile-card__stat">
              <Text type="secondary">{t("Share")}</Text>
              <Text strong>{`${formatNumber(record?.percentage ?? 0, 1, ",", ".")}%`}</Text>
            </Flex>
          </Flex>
        </div>
      ))}
    </Flex>
  )
}

export default AlertsByBankMobileTable
